// import {  Grid, LinearProgress } from "@mui/material";
// // import Logo from "assets/login/Vit_white.png";

// function Loading() {
//   return (
//     <Grid
//       data-testid="loading-component"
//       container
//       spacing={2}
//       direction="column"
//       alignItems="center"
//       justifyContent="center"
//       style={{ minHeight: "85vh" }}
//     >
//       <Grid xs={12} sm={12} md={12} lg={12} item >
//         {/* <Box
//           className="w-24 animate-bounce"
//           component="img"
//           // src={Logo}
//           alt="Logo"
//         /> */}
//       </Grid>
//       <Grid xs={12} sm={12} md={12} lg={12} item >
//         <LinearProgress data-testid='loader' style={{backgroundColor:"#F7901D"}} className="w-60" />
//       </Grid>
//     </Grid>
//   );
// }

// export default Loading;


import { SparkleLargeSVG, SparkleSmallSVG } from "assets/images/icons";
import React from "react";

function Loading() {
 return (
        <>
            <style>
                {`
                /* Keyframe for the pulsing size animation on the icon */
                @keyframes pulse {
                    0%   { transform: scale(0.5); }
                    50%  { transform: scale(1.2); }
                    100% { transform: scale(0.5); }
                }

                /* Keyframe for the inverse pulsing size animation */
                @keyframes inverse-pulse {
                    0%   { transform: scale(1.4); }
                    50%  { transform: scale(0.8); }
                    100% { transform: scale(1.4); }
                }

                /* Keyframe for the border rotation */
                @keyframes rotate {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }

                /* Keyframe for the independent rotation of the smaller sparkle */
                @keyframes rotate-small {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }

                .sparkle-icon {
                    animation: pulse 1s ease-in-out infinite;
                }
                
                .conic-gradient-border {
                    background: conic-gradient(
                        #F7901D,
                        #FFF
                    );
                    padding: 2px;
                    border-radius: 50%;
                    animation: rotate 1.5s linear infinite;
                    filter: blur(0px);
                    -webkit-filter: blur(0px);
                }
                
                .conic-gradient-border::before {
                    content: '';
                    position: absolute;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                    width: calc(100% - 4px);
                    height: calc(100% - 4px);
                    background: #fff;
                    border-radius: 50%;
                }

                .white-border {
                    position: absolute;
                    background-color: white;
                    border-radius: 50%;
                }
                `}
            </style>
            <div 
                className="flex items-center justify-center min-h-screen"
            >
                <div className="relative w-[65px] h-[65px] flex items-center justify-center">
                    <div 
                        className="absolute conic-gradient-border" 
                        style={{ 
                            width: '100%', 
                            height: '100%', 
                            zIndex: 9
                        }}
                    />
                    {/* Main sparkle icon with white border */}
                    <div 
                        className="relative"
                        style={{
                            width: '40px',
                            height: '40px',
                            zIndex: 10,
                        }}
                    >
                        <div 
                            className="white-border" 
                            style={{ 
                                width: '45px', 
                                height: '45px', 
                                top: '50%', 
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                            }}
                        />
                        <div
                            style={{
                                width: '100%',
                                height: '100%',
                                zIndex: 11,
                                animation: 'pulse 1s ease-out infinite',
                                position: 'absolute',
                                top: '0',
                                left: '0',
                            }}
                        >
                            <SparkleLargeSVG />
                        </div>
                    </div>
                    {/* Smaller sparkle icon */}
                    <div 
                        className="absolute" 
                        style={{ 
                            width: '30px', 
                            height: '30px', 
                            zIndex: 11,
                            animation: 'inverse-pulse 1s ease-in-out infinite',
                            transform: 'translate(20px, 20px)' 
                        }}
                    >
                        <SparkleSmallSVG />
                    </div>
                </div> <span className='pl-[10px] text-sm text-[grey]'> Loading... </span>
            </div>
        </>
    );
}

export default Loading;
